
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.25 21.43h-6.5a.5.5 0 010-1h6.5a.5.5 0 010 1zm0 2.57h-6.5a.5.5 0 110-1h6.5a.5.5 0 110 1zm-.45-5.5H9.3a1.36 1.36 0 01-1.32-1.1 27.27 27.27 0 00-2.67-6.85 7.26 7.26 0 011.36-8.27 7.4 7.4 0 018.3-1.67 7.26 7.26 0 014.45 7.1 8.85 8.85 0 01-.94 3.33 25.58 25.58 0 00-2.36 6.37 1.34 1.34 0 01-1.32 1.09zM12.02 1a6.43 6.43 0 00-4.63 1.98A6.26 6.26 0 006.2 10.1a28.06 28.06 0 012.76 7.1.35.35 0 00.34.3h5.5a.35.35 0 00.35-.3 26.63 26.63 0 012.44-6.62 7.8 7.8 0 00.83-2.94 6.26 6.26 0 00-3.85-6.12A6.46 6.46 0 0012.02 1z"}})])
          )
        }
      }
    